import Countries from './Countries.json';


const main = {
  all: Countries
}
export default main;

